<p-drawer
    [id]="id()"
    [styleClass]="'custom-drawer'"
    [position]="position()"
    role="dialog"
    aria-modal="true"
    [modal]="modal()"
    [showCloseIcon]="showCloseIcon()"
    [blockScroll]="blockScroll()"
    [closeOnEscape]="closeOnEscape()"
    [(visible)]="isVisible">
    @let title$ = title();
    @if (title$) {
        <ng-template #header>
            <div>
                {{ title$ | translate }}
            </div>
        </ng-template>
    }

    <ng-content select="[body]"></ng-content>
</p-drawer>
